/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeader").classList.remove("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            const comparePrices = [];

            // Shopify line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // Compare at price from injected Liquid object
            const compareAtPrice = variantCompareAtPrices?.[item.variant_id];
            if (compareAtPrice && compareAtPrice > item.final_price / item.quantity) {
                const totalCompare = compareAtPrice * item.quantity;
                comparePrices.push(totalCompare);
            }

            if (comparePrices.length > 0) {
                const greatestComparePrice = Math.max(...comparePrices);

                if (greatestComparePrice > item.final_line_price) {
                    HTML += `
                <s>${price(greatestComparePrice)}</s>
                ${price(item.final_line_price)}
                <span><br>(Save ${price(greatestComparePrice - item.final_line_price)})</span>
            `;
                    return HTML;
                }
            }

            // No compare price? Just show the regular price
            HTML += price(item.final_line_price);
            return HTML;
        }


        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                <div>
                    <div class="miniCartBodyItemFlex flexTop">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                    <div class="miniCartBodyItemFlex flexBottom">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">+</button>
                        </div>
                        <button class="miniCartBodyItemRemove">
                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.0502 4.73999H2.0152C1.6002 4.73999 1.2627 4.40249 1.2627 3.98749C1.2627 3.57249 1.6002 3.23499 2.0152 3.23499H19.0502C19.4652 3.23499 19.8027 3.57249 19.8027 3.98749C19.8027 4.40249 19.4652 4.73999 19.0502 4.73999Z" fill="#6D6D6D"/>
                                <path d="M10.9193 19.77H10.1443C7.3743 19.77 5.8493 19.77 4.7643 18.7575C3.6818 17.745 3.5793 16.2225 3.3943 13.4575L2.9343 6.54497C2.9068 6.12997 3.2193 5.77247 3.6343 5.74497C4.0493 5.71747 4.4068 6.02997 4.4343 6.44497L4.8943 13.3575C5.0593 15.8175 5.1418 17.0525 5.7918 17.66C6.4418 18.2675 7.6793 18.2675 10.1443 18.2675H10.9193C13.3843 18.2675 14.6218 18.2675 15.2718 17.66C15.9218 17.0525 16.0043 15.8175 16.1693 13.3575L16.6293 6.44497C16.6568 6.02997 17.0168 5.71747 17.4293 5.74497C17.8443 5.77247 18.1568 6.12997 18.1293 6.54497L17.6693 13.4575C17.4843 16.2225 17.3843 17.745 16.2993 18.7575C15.2168 19.77 13.6893 19.77 10.9193 19.77Z" fill="#6D6D6D"/>
                                <path d="M8.52687 14.76C8.14437 14.76 7.81937 14.47 7.77937 14.0825L7.27937 9.07252C7.23687 8.66002 7.53937 8.29002 7.95187 8.25002C8.36437 8.20752 8.73437 8.51002 8.77437 8.92252L9.27437 13.9325C9.31687 14.345 9.01437 14.715 8.60187 14.755C8.57687 14.7575 8.55187 14.76 8.52687 14.76Z" fill="#6D6D6D"/>
                                <path d="M12.5376 14.76C12.5126 14.76 12.4876 14.76 12.4626 14.755C12.0501 14.7125 11.7476 14.345 11.7901 13.9325L12.2901 8.92252C12.3326 8.51002 12.7001 8.20752 13.1126 8.25002C13.5251 8.29252 13.8276 8.66002 13.7851 9.07252L13.2851 14.0825C13.2451 14.47 12.9201 14.76 12.5376 14.76Z" fill="#6D6D6D"/>
                                <path d="M16.0444 4.73998C15.9794 4.73998 15.9469 4.73998 15.9169 4.73998C15.3594 4.72498 14.8269 4.54748 14.3744 4.21998C13.9219 3.89498 13.5844 3.44498 13.3944 2.92248C13.3844 2.89498 13.3744 2.86248 13.3519 2.79998L13.2544 2.50748C13.1894 2.31498 13.1494 2.18998 13.1219 2.13748C13.0119 1.92748 12.8069 1.77998 12.5744 1.74248C12.5144 1.73248 12.3819 1.73248 12.1819 1.73248H8.88691C8.68441 1.73248 8.55191 1.73248 8.49441 1.74248C8.25941 1.77998 8.05691 1.92748 7.94691 2.13748C7.91941 2.18998 7.87691 2.31748 7.81441 2.50748L7.71691 2.79998C7.69691 2.86248 7.68441 2.89248 7.67441 2.92248C7.48441 3.44498 7.14691 3.89498 6.69441 4.21998C6.24191 4.54498 5.70941 4.72498 5.15191 4.73998C5.12191 4.73998 5.08941 4.73998 5.02441 4.73998V3.23748C5.06941 3.23748 5.09441 3.23748 5.11441 3.23748C5.63441 3.22498 6.08441 2.89998 6.25941 2.41248C6.26691 2.39248 6.27441 2.36998 6.28941 2.32748L6.38691 2.03498C6.47941 1.75748 6.52941 1.60498 6.61191 1.44498C6.93941 0.814983 7.55441 0.372483 8.25691 0.259983C8.43441 0.232483 8.59441 0.232483 8.88691 0.232483H12.1819C12.4744 0.232483 12.6344 0.232483 12.8119 0.259983C13.5144 0.372483 14.1269 0.814983 14.4569 1.44498C14.5394 1.60248 14.5894 1.75498 14.6819 2.03248L14.7794 2.32748C14.7944 2.37248 14.8019 2.39248 14.8094 2.41248C14.9869 2.89998 15.4369 3.22498 15.9544 3.23748C15.9744 3.23748 15.9994 3.23748 16.0444 3.23748V4.73998Z" fill="#6D6D6D"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }
    });

    // update checkout total
    document.querySelector("#miniCartFooterCheckoutPrice").textContent = `Total: ${price(cart.items_subtotal_price)}`;
}

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", function () {
    this.classList.add("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}

// open cart on load for styling
// openCart(true);
